import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {ManufacturerService} from 'src/app/modules/pbm/services/manufacturer.service';
import {ManufacturerDTO} from 'src/app/modules/pbm/models/ManufacturerDTO';
import {KeycloakService} from 'keycloak-angular';
import {SharedService} from '../../../../common/services/shared-service';

@Component({
  selector: 'app-add-manufacturer-dialog',
  templateUrl: './add-manufacturer-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class AddManufacturerDialogComponent implements OnInit {

  manufacturerNameFormControl: FormControl;
  editManufacturer = new ManufacturerDTO();
  isEdit = false;
  userFirstLastName = '';
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<AddManufacturerDialogComponent>,
    private manufacturerService: ManufacturerService,
    private keycloakService: KeycloakService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public id: number
  ) {
    this.manufacturerNameFormControl = new FormControl('');
    if (id != null) {
      this.isEdit = true;
      this.getManufacturer(id);
    }
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  onSaveClick(): void {
    const manufacturerDTO = new ManufacturerDTO();
    manufacturerDTO.name = this.manufacturerNameFormControl.value;

    if (this.isEdit) {
      manufacturerDTO.manufacturerId = this.editManufacturer.manufacturerId;
      manufacturerDTO.created = this.editManufacturer.created;
      manufacturerDTO.createdBy = this.editManufacturer.createdBy;
      manufacturerDTO.updated = new Date();
      manufacturerDTO.updatedBy = this.userFirstLastName;
    }
    else {
      manufacturerDTO.created = new Date();
      manufacturerDTO.createdBy = this.userFirstLastName;
    }

    this.manufacturerService.saveManufacturer(manufacturerDTO).subscribe(
      response => {
        this.sharedService.openSnackBar(`Manufacturer ${response.name} saved successfully`, 'Dismiss');
        this.dialogRef.close();
      },
      error => {
        this.errorMessage = error.message;
      }
    );
  }

  getManufacturer(id: number) {
    this.manufacturerService.getManufacturer(id).subscribe(
      response => {
        this.editManufacturer = response;
        this.manufacturerNameFormControl.setValue(this.editManufacturer.name);
      }
    );
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
